// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#328277","uploadButton":"UploadButton_uploadButton__1PuAc","pendingContainer":"UploadButton_pendingContainer__suhjq"};